export default __webpack_public_path__ + "static/media/cookie.985080da.svg";